<template>
    <v-dialog
      content-class="mobile-modal"
      v-model="status"
      transition="dialog-bottom-transition"
      width="100%"
      persistent
      scrollable
    >
        <v-card class="article-container">
          <v-card-title>
            <v-img
              class="preview"
              max-width="200"
              src="/img/logo.png"
              alt="HealthNow"
            ></v-img>
            <div @click="closeModal" class="icon -close"></div>
          </v-card-title>
          <v-card-text>
            <div v-if="article.img" class="faq-image">
              <img class="cont-img" :src="'/img/faq/mobile/' + article.img">
            </div>
            <div class="faq-content">
              <p v-if="article.title" class="faq-title">{{ article.title }}</p>
              <p v-if="article.desc" class="faq-desc" v-html="article.desc"></p>

              <template v-if="article.list">
                <ListDescription :listDesc="article.list"></ListDescription>
              </template>

              <template v-if="article.multiList">
                <NestedListDescription :multiListDesc="article.multiList"></NestedListDescription>
              </template>

              <template v-if="article.multiDesc">
                <p class="faq-desc" v-for="(desc, multiId) in article.multiDesc" :key="multiId" v-html="desc"></p>
              </template>

              <div class="article-functions">
                <SocialShare
                  :faqArticle="article"
                  :articleDir="{
                    tab: directory[0],
                    article: directory[1]
                  }"
                ></SocialShare>
                <RateArticle
                  :faqArticle="article"
                  mobile
                ></RateArticle>
              </div>
            </div>
          </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
import ListDescription from './ListDescription.vue';
import NestedListDescription from './NestedListDescription.vue';
import SocialShare from './SocialShare.vue';
import RateArticle from './RateArticle.vue';

export default {
  name: 'ArticleModal',
  components: {
    ListDescription,
    NestedListDescription,
    SocialShare,
    RateArticle,
  },
  props: {
    status: Boolean,
    article: Object,
    directory: Array,
  },
  methods: {
    closeModal() {
      this.$emit('modal-close', false);
    },
  },
};
</script>
